import { useEffect } from 'react';
import { Outlet, useLocation, useNavigate } from 'react-router';

import { Tabs, TabsContent, TabsList, TabsTrigger } from '@/components/ui/tabs';

import { useSettingsTabStore } from '@/stores/settingsTabStore';

import { USER_ROLES } from '@/constants/global-constants';
import { adminRoutes, privateRoutes } from '@/constants/route-settings';

export function SettingsPage() {
  const { activeTab, setActiveTab } = useSettingsTabStore();

  const navigate = useNavigate();
  const location = useLocation();

  const handleTabChange = (tab: string) => {
    navigate(`${adminRoutes.settings}/${tab}`);
    setActiveTab(tab);
  };

  useEffect(() => {
    if (location.pathname.includes('processes')) {
      setActiveTab(privateRoutes[USER_ROLES.ADMIN.value].processes.list);
      return;
    }
    if (location.pathname.includes('file-validation')) {
      setActiveTab(privateRoutes[USER_ROLES.ADMIN.value].fileValidation);
      return;
    }
    if (location.pathname.includes('tags')) {
      setActiveTab(privateRoutes[USER_ROLES.ADMIN.value].tags);
      return;
    }
    if (location.pathname.includes('indexes')) {
      setActiveTab(privateRoutes[USER_ROLES.ADMIN.value].indexes);
      return;
    }
  }, [location.pathname]);

  return (
    <div className="flex h-full flex-col">
      <Tabs
        value={activeTab}
        onValueChange={handleTabChange}
        className="flex h-full flex-col"
      >
        {/* Fixed tab navigation - doesn't scroll */}
        <div className="h-[50px] w-full flex-shrink-0 border-b bg-white px-4 sm:h-[80px] sm:px-12">
          <TabsList className="h-full border-none bg-transparent p-0">
            <TabsTrigger
              value={privateRoutes[USER_ROLES.ADMIN.value].fileValidation}
            >
              <div className="px-2">Валідація файлів</div>
            </TabsTrigger>
            <TabsTrigger value={privateRoutes[USER_ROLES.ADMIN.value].tags}>
              <div className="px-2">Мітки</div>
            </TabsTrigger>
            <TabsTrigger value={privateRoutes[USER_ROLES.ADMIN.value].indexes}>
              <div className="px-2">Індекси</div>
            </TabsTrigger>
            <TabsTrigger
              value={privateRoutes[USER_ROLES.ADMIN.value].processes.list}
            >
              <div className="px-2">Процеси</div>
            </TabsTrigger>
            <TabsTrigger
              value={privateRoutes[USER_ROLES.ADMIN.value].directories}
            >
              <div className="px-2">Дирекції</div>
            </TabsTrigger>
          </TabsList>
        </div>

        {/* Scrollable content area for tab content */}
        <div className="flex-grow overflow-auto p-3 sm:p-12">
          <div className="mx-0 h-full max-w-[1500px]">
            <TabsContent
              value={privateRoutes[USER_ROLES.ADMIN.value].fileValidation}
              className="mt-0 h-full data-[state=active]:flex data-[state=active]:flex-col"
            >
              <Outlet />
            </TabsContent>

            <TabsContent
              value={privateRoutes[USER_ROLES.ADMIN.value].tags}
              className="mt-0 h-full data-[state=active]:flex data-[state=active]:flex-col"
            >
              <Outlet />
            </TabsContent>

            <TabsContent
              value={privateRoutes[USER_ROLES.ADMIN.value].indexes}
              className="mt-0 h-full data-[state=active]:flex data-[state=active]:flex-col"
            >
              <Outlet />
            </TabsContent>

            <TabsContent
              value={privateRoutes[USER_ROLES.ADMIN.value].processes.list}
              className="mt-0 h-full data-[state=active]:flex data-[state=active]:flex-col"
            >
              <Outlet />
            </TabsContent>

            <TabsContent
              value={privateRoutes[USER_ROLES.ADMIN.value].directories}
              className="mt-0 h-full data-[state=active]:flex data-[state=active]:flex-col"
            >
              <Outlet />
            </TabsContent>
          </div>
        </div>
      </Tabs>
    </div>
  );
}
